var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 13.75C12.7469 13.75 15.1491 14.9312 16.4556 16.6937L15.0741 17.347C14.0106 16.087 12.1356 15.25 10.0004 15.25C7.86515 15.25 5.99015 16.087 4.92665 17.347L3.5459 16.693C4.8524 14.9305 7.2539 13.75 10.0004 13.75ZM10.0004 2.5C10.995 2.5 11.9488 2.89509 12.652 3.59835C13.3553 4.30161 13.7504 5.25544 13.7504 6.25V8.5C13.7503 9.46635 13.3772 10.3954 12.7089 11.0933C12.0406 11.7913 11.1286 12.2043 10.1631 12.2463L10.0004 12.25C9.00584 12.25 8.05201 11.8549 7.34875 11.1517C6.64549 10.4484 6.2504 9.49456 6.2504 8.5V6.25C6.25045 5.28365 6.62355 4.35463 7.29189 3.65667C7.96023 2.95871 8.87221 2.54569 9.83765 2.50375L10.0004 2.5ZM10.0004 4C9.42649 3.99997 8.87426 4.21924 8.4567 4.61296C8.03914 5.00668 7.78782 5.54508 7.75415 6.118L7.7504 6.25V8.5C7.74983 9.08568 7.97766 9.6485 8.38548 10.0689C8.79329 10.4892 9.34894 10.734 9.93437 10.7512C10.5198 10.7684 11.0889 10.5566 11.5206 10.1609C11.9524 9.76519 12.2129 9.2167 12.2466 8.632L12.2504 8.5V6.25C12.2504 5.65326 12.0133 5.08097 11.5914 4.65901C11.1694 4.23705 10.5971 4 10.0004 4Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNameIcon);
export default __webpack_public_path__ + "static/media/userNameIcon.5287731dff7373b70a4cdb29a396ae44.svg";
export { ForwardRef as ReactComponent };